module.exports = __webpack_public_path__ + "static/img/zycp_shiwuxing_a.16344df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/zycp_shiwuxing_a.jpg
// module id = 4Qsh
// module chunks = 1